export function isCouponModificationNotAllowedError(error: Error): boolean {
  return error.name === "CouponModificationNotAllowedError";
}

export class CouponCopyError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "CouponCopyError";
  }
}

/**
 * Maps known backend error messages to i18n keys.
 * Falls back to the provided default key if no match is found.
 */
const backendErrorMessageToI18nKey: Record<string, string> = {
  "Start date cannot be before open date":
    "backendErrors.startDateBeforeOpenDate",
  "End date cannot be before closed date":
    "backendErrors.endDateAfterClosedDate",
  "Package with this code already exists":
    "backendErrors.packageCodeAlreadyExists",
  "Package code already exists": "backendErrors.packageCodeAlreadyExists",
};

export function getLocalizedErrorKey(
  backendErrorMessage: string | undefined,
  fallbackKey: string,
): string {
  if (!backendErrorMessage) return fallbackKey;
  return backendErrorMessageToI18nKey[backendErrorMessage] ?? fallbackKey;
}
